import { DefaultId, FBDate } from "./Globals";
import { TranslatedContent } from "./Language";
import Project from "./Project";


const stringToStringArray = (term: string): string[] => {
    const arr: string[] = []
    for (let index = 0; index < term.length; index++) {
        const element = term[index];
        arr.push(element)
    }
    return arr
}

export const NiceNumber = (input: number): string => {
    if(input === 0) return "0"
    if(!input) return ""
    const number = input.toFixed(0)
    const numberAsString = (number.toString())
    const numberAsArray = stringToStringArray(numberAsString).reverse()
    let formattedOutput = ""
    for (let index = 0; index < numberAsArray.length; index++) {
        const element = numberAsArray[index];
        if (index > 0 && index % 3 === 0) formattedOutput = formattedOutput + '.'
        formattedOutput = formattedOutput + element
    }

    const formattedOutputArray = stringToStringArray(formattedOutput).reverse()

    return formattedOutputArray.join('')
}

export const NiceNumberWithCurrency = (number: number): string => {
    return NiceNumber(number) + " DKK"
}

const intrest_suffix = " %"
export const NiceIntrestRate = (number: number, noDecimals?: boolean): string => {
    if (noDecimals) return Math.round(number * 100) + intrest_suffix
    return ((number * 100).toFixed(2)) + intrest_suffix
}

export const NiceDate = (fbDate: FBDate): string => {
    const date = new Date(fbDate)
    const dom = date.getDate()
    const month = date.getMonth() + 1
    return dom + '/' + month + '/' + date.getFullYear()
}


export const NiceDuration = (project: Project): TranslatedContent => {
    const months = project.finance.durationMin + " - " + project.finance.durationMax
    return {
        "da": months + " mdr.",
        [DefaultId]: months + " mo.",
    }
}
